/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, July 2020
 */

import React, { useCallback, useContext, useMemo } from 'react';
import { FlowBlockTargetGrid as Model } from '@staffino/model';
import { TargetGridBlock as Component } from '@staffino/flow-controls';
import { useFormContext } from 'react-hook-form';
import useObjects from '../use-objects-hook';
import FlowContext from '../flow-context';
import ConditionEvaluator from '../condition-evaluator/condition-evaluator';
import useBridge from '../use-bridge-hook';

type Props = {
  block: Model;
};

function insertString(str, index, value) {
  return str.substr(0, index) + value + str.substr(index);
}

const TargetGridBlock = ({ block }: Props) => {
  const bridge = useBridge();
  const form = useFormContext();

  const { definition, stateManager, handleSubmit } = useContext(FlowContext);
  const evaluator = useMemo(
    () => new ConditionEvaluator(stateManager, bridge, definition, form),
    [stateManager, bridge, definition, form],
  );
  const handleSelect = useCallback(
    (target) => {
      stateManager.setTargetId(target.id);
      stateManager
        .reevaluateConditions(form.getValues({ nest: true }), evaluator)
        .then(() => handleSubmit?.(form.getValues({ nest: true })));
    },
    [stateManager, evaluator, handleSubmit, form],
  );
  let targetId = bridge.targetId;
  if (targetId.indexOf('-') === -1) {
    targetId = insertString(targetId, 8, '-');
    targetId = insertString(targetId, 13, '-');
    targetId = insertString(targetId, 18, '-');
    targetId = insertString(targetId, 23, '-');
  }

  const targets = useObjects('target', { parentId: targetId });
  return <Component targets={targets} onSelect={handleSelect} />;
};

export default TargetGridBlock;
